angular.module('impactx.usergroups').controller('EditUserGroupCatalogRightController', EditUserGroupCatalogRightController);
EditUserGroupCatalogRightController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$routeParams',
    'ToolbarService',
    'TranslationService',
    '$redirect'
];

function EditUserGroupCatalogRightController($scope, dataGen, BackService, ToastService, $routeParams, ToolbarService, TranslationService, $redirect) {
    var ctrl = this;

    var changeEvents = ['rv.assignOne', 'rv.assignAll', 'rv.unassignOne', 'rv.unassignAll'];

    dataGen.getData($scope, {id: $routeParams.id}, "/usergroup/catalogright/view").then(function () {
        defineButtons();
    });

    ctrl.onUXEvent = function (eventName, data, eventSource) {
        if (eventSource && changeEvents.indexOf(eventName) >= 0) {
            var dataObj = {
                usgId: $scope.data.id,
                vcatIds: []
            };
            angular.forEach(data, function(entry) {
                dataObj.vcatIds.push(entry.id);
            });
            dataGen.postAsForm({}, dataObj, "/usergroup/catalogright/getnew").then(function (response) {
                if (response && response.data) {
                    $scope.data.catalogRights = response.data.entries;
                }
            });
        }
    };

    ctrl.save = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/usergroup/catalogright/save").then(function () {
            $redirect.redirectTo(null, "usergrouplist");
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get("save"),
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}